// extracted by mini-css-extract-plugin
export default {"Bluecheese":"#615CFF","LightestAccessible":"#6F7781","container":"G1ac839","month":"Gf94181","day":"Ga09e97","dayNumeric":"Gf642c5"};